/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { WebAppInitAppBootstrapQueryResponse, WebAppInitAppBootstrap401, WebAppInitAppBootstrap403 } from "../models/WebAppInitAppBootstrap";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { webAppInitAppBootstrap } from "../axios/webAppInitAppBootstrap";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const webAppInitAppBootstrapQueryKey = () => ["api-v2", { url: '/web-app/v1/app-init' }] as const

export type WebAppInitAppBootstrapQueryKey = ReturnType<typeof webAppInitAppBootstrapQueryKey>

export function webAppInitAppBootstrapQueryOptions(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = webAppInitAppBootstrapQueryKey()
        return queryOptions<WebAppInitAppBootstrapQueryResponse, ResponseErrorConfig<WebAppInitAppBootstrap401 | WebAppInitAppBootstrap403>, WebAppInitAppBootstrapQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return webAppInitAppBootstrap({ ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get app init payload (user, client, stations, stations-groups)
 * {@link /web-app/v1/app-init}
 */
export function useWebAppInitAppBootstrap<TData = WebAppInitAppBootstrapQueryResponse, TQueryData = WebAppInitAppBootstrapQueryResponse, TQueryKey extends QueryKey = WebAppInitAppBootstrapQueryKey>(options: 
{
  query?: Partial<QueryObserverOptions<WebAppInitAppBootstrapQueryResponse, ResponseErrorConfig<WebAppInitAppBootstrap401 | WebAppInitAppBootstrap403>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? webAppInitAppBootstrapQueryKey()
         

         const query = useQuery({
          ...webAppInitAppBootstrapQueryOptions(config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<WebAppInitAppBootstrap401 | WebAppInitAppBootstrap403>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}